// extracted by mini-css-extract-plugin
export default {"brandPromo":"oF-z","carousel":"pF-z"};